import { useState } from "react";

const useRightDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openRightDrawer = () => {
    setIsOpen(true);
  };

  const closeRightDrawer = () => {
    setIsOpen(false);
  };

  return { isOpen, openRightDrawer, closeRightDrawer };
};

export default useRightDrawer;
